import { render, staticRenderFns } from "./PrivateOrderDetailMobile.vue?vue&type=template&id=087a87b4&scoped=true&"
import script from "./PrivateOrderDetailMobile.vue?vue&type=script&lang=js&"
export * from "./PrivateOrderDetailMobile.vue?vue&type=script&lang=js&"
import style0 from "./PrivateOrderDetailMobile.vue?vue&type=style&index=0&id=087a87b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087a87b4",
  null
  
)

export default component.exports